import { DASHBOARD_WIDGET_KINDS } from "./dashboard-widget-values";
import { z } from "zod";
import { computedDecimalSchema } from "../values/decimal";

const coverageSchema = z.object({
  complete: z.boolean(),
  note: z.string().optional(),
  missingPriceCount: z.number().int().positive().optional(),
});

export const dashboardWidgetDataSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal(DASHBOARD_WIDGET_KINDS.stat), value: computedDecimalSchema, coverage: coverageSchema }),
  z.object({
    kind: z.literal(DASHBOARD_WIDGET_KINDS.bar),
    points: z.array(z.object({ label: z.string(), value: z.number().finite() })),
    coverage: coverageSchema,
  }),
]);

export type DashboardWidgetData = z.infer<typeof dashboardWidgetDataSchema>;

export const dashboardAreaResponseSchema = z.record(z.string(), dashboardWidgetDataSchema);
export type DashboardAreaResponse = z.infer<typeof dashboardAreaResponseSchema>;

export const dashboardRangeQuerySchema = z
  .object({ start: z.string().date(), end: z.string().date() })
  .refine(({ start, end }) => start < end, { message: "start must be before end" });
